// extracted by mini-css-extract-plugin
export default {"form":"EditAddressEstimate_form__KzIn4"};